import { ProductListResponseSchema } from '@/schemas/catalog/catalogSchemas'
import { type IProductCard } from '@/schemas/catalog/product'
import { type IProductFilters } from '@/schemas/catalog/productFilters'
import { api, apiService } from '@/services/core/ApiService'
import { buildProductListTerm } from '@/services/domain/catalog/ProductFiltersService'

export interface IListProductsParams {
    filters: IProductFilters
    /** Página começando em 0. */
    page: number
    pageSize: number
}

// ===== LISTAR (GET product/list-products) =====

/**
 * Página da listagem `/produtos` com os filtros serializados em `term`. Erro HTTP ou resposta fora do contrato rejeitam
 * com `ApiError`, sem toast: leitura pública silenciosa como no legado (o erro só ia para o console), a tela decide pelo
 * `isError`. Sem loader: o scroll infinito mostra o próprio indicador.
 */
export const listProductsService = ({ filters, page, pageSize }: IListProductsParams): Promise<IProductCard[]> =>
    apiService(api)
        .get('product/list-products', ProductListResponseSchema, {
            params: { term: buildProductListTerm(filters), page, pageSize },
        })
        .onError(() => {}, { useDefaultErrorHandler: false })
        .execute()
        .then((data) => data.products)
